import React from 'react';
import { IProps } from './types';

const InnerPageAAds: React.FC<IProps> = (props) => props.imageUrls ? (
  <div className="member-only__inner-page-a-ads">
    <>
      <div
        className="member-only__inner-page-a-ads-banner-pc"
        style={{
          backgroundImage: `url(${props.imageUrls[0]})`
        }}
      />
      <div
        className="member-only__inner-page-a-ads-banner-mobile"
        style={{
          backgroundImage: `url(${props.imageUrls[1]})`
        }}
      />
    </>
  </div>
) : null;

export default InnerPageAAds;
